export class WorkshopSupplier {
  [key: string]: any;
  _id?: string;
  _rev?: string;
  type?: string = "workshopSupplier";
  options?: string[] = [];
}